import { Component, OnInit } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

import { HeaderStateService } from '../../../main/headers/services/header-state.service';
import { AssignmentEventTypeEnum } from '../../../shared/enums/assignment-event-type.enum';
import { AssignmentsOverviewModel } from '../../models/assignments-overview.model';
import { AssignmentStateService } from '../../services/assignment-state.service';
import { AssignmentsFilterStateService } from '../../services/assignments-filter-state.service';
import { AssignmentsHelperService } from '../details/services/assignments-helper.service';
import { AssignmentsFilterModalComponent } from '../assignments-filter-modal/assignments-filter-modal.component';
import { ExchangeAssignmentsModalComponent } from '../exchange-assignments-modal/exchange-assignments-modal.component';

@Component({
    templateUrl: './exchange-assignments.component.html',
    styleUrl: './exchange-assignments.component.scss',
    providers: [AssignmentsFilterStateService]
})
export class ExchangeAssignmentsComponent implements OnInit {
    selectedAssignments: AssignmentsOverviewModel[] = [];
    assignmentEventType = AssignmentEventTypeEnum;

    constructor(
        public assignmentsStateService: AssignmentStateService,
        private assignmentsFilterStateService: AssignmentsFilterStateService,
        private headerStateService: HeaderStateService,
        private bsModalService: BsModalService,
        public assignmentStateService: AssignmentStateService,
        private translocoService: TranslocoService,
        private assignmentsHelperService: AssignmentsHelperService
    ) {
        this.headerStateService.setDetailHeader(
            this.translocoService.translate('main.header.exchangeAssignmentsTitle'),
            this.translocoService.translate('main.header.exchangeAssignmentsDescription'),
            '/assignments',
            'fa-solid fa-filter text-primary'
        );
    }

    ngOnInit(): void {
        const currentFilter = this.assignmentsStateService.exchangeAssignmentsFilterSubject.value;
        this.assignmentsStateService.loadUpcomingAssignments(currentFilter);
        this.registerEvents();
    }

    public openSubstituteModal(): void {
        const exchangeAssignments = this.assignmentsHelperService.transformOverviewModelsToExchangeModel(this.selectedAssignments);
        const initialState = { exchangeAssignments: exchangeAssignments, isVacacyAllowed: true };
        const modalRef: BsModalRef = this.bsModalService.show(ExchangeAssignmentsModalComponent, {
            ignoreBackdropClick: true,
            initialState
        });

        modalRef?.content.onSuccess.subscribe((success: boolean) => {
            if (success) {
                this.resetSelectedAssignments();
                let currentFilter = this.assignmentsStateService.exchangeAssignmentsFilterSubject.value;
                this.assignmentStateService.loadUpcomingAssignments(currentFilter);
            }
        });
    }

    public onAssignmentSelected(assignments: AssignmentsOverviewModel[]): void {
        this.selectedAssignments = assignments;
    }

    public openFilterModal(): void {
        const modalRef: BsModalRef = this.bsModalService.show(AssignmentsFilterModalComponent, {
            ignoreBackdropClick: true,
            initialState: {
                isFilterForPastAssignmentEnabled: false
            }
        });
        modalRef.content.assignmentsFilterSubject = this.assignmentsStateService.exchangeAssignmentsFilterSubject;
        modalRef.content.loadSavedFilters();
    }

    private registerEvents(): void {
        this.headerStateService.getActionClickedEvent().subscribe((x) => {
            this.openFilterModal();
        })

        this.assignmentsFilterStateService.getIsAnyFilterDisplayedEvent().subscribe(x => {
            this.headerStateService.updateIsActiveStatusIndicatorDisplayed(x);
        });
    }

    private resetSelectedAssignments(): void {
        this.selectedAssignments = [];
    }
}
